import {otsBaseApi} from "../../ots-api";
import {ProductionVolume, ProductionVolumeSearchCriteria} from "../../../model/production-volume";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ProductionVolumes"]});

const productionVolumeApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchProductionVolumes: builder.query<
      ProductionVolume[],
      ProductionVolumeSearchCriteria
    >({
      query: (criteria) => ({
        url: `/production-volumes/search`,
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "ProductionVolumes", id} as const)),
            {type: "ProductionVolumes", id: "LIST"}
          ];
        } else {
          return [{type: "ProductionVolumes", id: "LIST"}];
        }
      },
    }),
    getProductionVolume: builder.query<ProductionVolume, string>({
      query: (id) => ({
        url: `/production-volumes/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "ProductionVolumes", id}]
    }),
    createProductionVolume: builder.mutation<ProductionVolume, Partial<ProductionVolume>>({
      query: (mapping) => ({
        url: "/production-volumes",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "ProductionVolumes", id: "LIST"}]
    }),
    updateProductionVolume: builder.mutation<ProductionVolume, Partial<ProductionVolume>>({
      query: (mapping) => ({
        url: "/production-volumes",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "ProductionVolumes", id}]
    }),
    deleteProductionVolume: builder.mutation<void, Partial<ProductionVolume>>({
      query: (mapping) => ({
        url: "/production-volumes",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "ProductionVolumes", id}]
    })
  })
});

export const {
  useSearchProductionVolumesQuery,
  useGetProductionVolumeQuery,
  useCreateProductionVolumeMutation,
  useUpdateProductionVolumeMutation,
  useDeleteProductionVolumeMutation,
} = productionVolumeApi;
